import React, { FC } from 'react';
import IconButton from '../IconButton/IconButton';
import ShareIcon from '../Icons/ShareIcon';

type TTerritoryDetailsShareTerritoryProps = {
  openShareModal: () => void;
};

export const TerritoryDetailsShareTerritory: FC<TTerritoryDetailsShareTerritoryProps> = ({ openShareModal }) => (
  <div className="md:absolute top-[13px] right-4">
    <IconButton
      onClick={openShareModal}
      className="!w-10 !h-10 !bg-t2-neutral-grey01 group-hover/sidebar:!bg-t2-shades-white border border-t2-neutral-grey03 rounded-full"
    >
      <ShareIcon className="w-4 h-4 md:w-5 md:h-5" />
    </IconButton>
  </div>
);
